import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { checkValueEmpty } from '../../helpers/checkValueEmpty';
import { isAddressEqual } from '../../helpers/isAddressEqual';
import { DatePickerISO } from '../DatePickerISO';
import { FiasOverrider } from '../FiasOverrider';
import { FieldWrapper } from '../FieldWrapper';
import { TextFieldWrapper } from '../TextFieldWrapper';
import { AddressEqualityCheckBox } from './components/AddressEqualityCheckBox';
export const HomeAddress = ({ value, onValueChange, registrationAddress, validationInfo, residenceDateValidationInfo, showDateInput = false, }) => {
    const [isAddressEquality, setIsAddressEquality] = useState(false);
    const { residenceDate, ...restAddress } = registrationAddress;
    const isRegistrationAddressEmpty = checkValueEmpty(restAddress);
    const onAddressMatch = (value) => {
        setIsAddressEquality(value);
        if (value) {
            onValueChange(registrationAddress);
            return;
        }
        onValueChange({});
    };
    const handleAddressChange = (newAddress) => {
        onValueChange({
            ...newAddress,
            residenceDate: value.residenceDate,
        });
    };
    const handleResidenceDateChange = (newDate) => {
        onValueChange({
            ...value,
            residenceDate: newDate.trim() || undefined,
        });
    };
    useEffect(() => {
        if (isAddressEquality) {
            onValueChange(registrationAddress);
            return;
        }
        setIsAddressEquality(!isRegistrationAddressEmpty && isAddressEqual(registrationAddress, value));
    }, [registrationAddress, value]);
    return (_jsxs(_Fragment, { children: [_jsxs(TextFieldWrapper, { label: "\u0424\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u0434\u0440\u0435\u0441", children: [_jsx(AddressEqualityCheckBox, { value: isAddressEquality, onValueChange: onAddressMatch, disabled: isRegistrationAddressEmpty }), !isAddressEquality && (_jsxs(_Fragment, { children: [value?.text && _jsx("div", { "data-tid": "homeAddressInput", children: value.text }), _jsx(FiasOverrider, { value: value, onValueChange: handleAddressChange, validationInfo: validationInfo })] }))] }), showDateInput && (_jsx(FieldWrapper, { label: "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u044F", children: _jsx(DatePickerISO, { value: value.residenceDate || '', onValueChange: handleResidenceDateChange, validationInfo: residenceDateValidationInfo, disabled: isAddressEquality }) }))] }));
};
